import React, {Component} from 'react';
import {findDOMNode} from 'react-dom';
import {TweenMax} from "gsap/TweenMax";

export const FadeIn = (WrappedComponent, duration) => {
    return class FadeIn extends Component {
        componentDidMount() {
            try {
                const el = findDOMNode(this);
                TweenMax.fromTo(el, duration || 0.3, {
                    opacity: 0
                }, {
                    opacity: 1
                })
            } catch (e) {
            }
        }

        render() {
            try {
                return <WrappedComponent {...this.props}/>
            } catch (e) {
            }
        }
    };
};


// WEBPACK FOOTER //
// ./src/components/fadeIn.js